import { render, staticRenderFns } from "./region-settings.vue?vue&type=template&id=aa891d0a&scoped=true"
import script from "./region-settings.vue?vue&type=script&lang=ts"
export * from "./region-settings.vue?vue&type=script&lang=ts"
import style0 from "./region-settings.vue?vue&type=style&index=0&id=aa891d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa891d0a",
  null
  
)

export default component.exports